import React from "react";


function ContestMessage({message}) {

  return (
    <>
    
      <div className="w-full flex flex-col items-center justify-start">
        <div className="w-full border border-border_color rounded-[14px] flex flex-col p-2 sm:p-4 items-center">
          <p className="w-full  min-h-[150px] p-3 rounded-xl text-sm">{message}</p>
        </div>
        <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-4 mt-10 sm:mt-24">
        </div>
      </div>
    </>
  );
}

export default ContestMessage;
